import React from 'react';
import { Button } from '@benzinga/core-ui';
import { SmartLink } from '@benzinga/analytics';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import type { AdvertorialProductProps } from './index';

export const AdvertorialProductWidgetLayout: React.FC<AdvertorialProductProps> = ({
  btn_label,
  description,
  disclosure_link,
  features,
  image,
  items,
  link,
  product_name,
  title,
}) => {
  return (
    <div className="bg-white border-2 border-[#e0e4e9] rounded-md p-4">
      <div className="flex flex-col md:flex-row md:gap-4 gap-2">
        <div className="w-full md:w-1/2">
          <img alt={title} className="w-full h-full object-cover" src={image} />
        </div>
        <div className="w-full md:w-1/2">
          <div className="product-items flex flex-col md:flex-row justify-between ">
            {items &&
              items?.length > 0 &&
              items.map(item =>
                item?.advertorial_item_label ? (
                  <React.Fragment key={item.advertorial_item_label}>
                    <div className="product-item mb-2 w-full md:w-1/2">
                      <div>
                        <b>{item.advertorial_item_label}</b>
                      </div>
                      {item?.advertorial_item_value ? <div>{item.advertorial_item_value} </div> : null}
                    </div>
                  </React.Fragment>
                ) : null,
              )}
          </div>

          <div
            className={`product-items flex flex-col justify-between ${items && items.length > 0 ? 'md:pt-6 pt-0' : 'pt-0'}`}
          >
            {features &&
              features?.length > 0 &&
              features.map(item =>
                item?.advertorial_feature_label ? (
                  <React.Fragment key={item.advertorial_feature_label}>
                    <div className="product-item mb-2 ">
                      <div>
                        <b>{item.advertorial_feature_label}</b>
                      </div>
                      {item?.advertorial_feature_value ? <div>{item.advertorial_feature_value} </div> : null}
                    </div>
                  </React.Fragment>
                ) : null,
              )}
          </div>
        </div>
      </div>
      <h3
        className="text-2xl font-bold md:mt-4 mt-2 mb-2"
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(title || '') }}
      />

      {product_name && (
        <div className="text-gray-500 text-sm mb-1">
          Promoted by {product_name}{' '}
          <a className="underline text-gray-500" href={disclosure_link}>
            17b disclosure
          </a>
        </div>
      )}

      {description && (
        <div className="ad-product-desc mb-4" dangerouslySetInnerHTML={{ __html: sanitizeHTML(description) }} />
      )}
      <SmartLink className="cta-link-button" href={link} label={`Ad Summary`}>
        <Button layout={'full'} size="md" variant="flat-blue">
          {btn_label}
        </Button>
      </SmartLink>
    </div>
  );
};
